// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"254":"555b0993","437":"2c45a2f6","453":"863bef69","474":"48838f4f","570":"9e759f1e","878":"c0714d3f"}[chunkId] + ".css";
};